var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.creatorLivestream)?_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('creator-livestream-viewers'),(_vm.creatorLivestream.startedAt)?_c('div',{staticClass:"small text-primary"},[_c('duration-timer',{attrs:{"timestamp":_vm.creatorLivestream.startedAt}})],1):_vm._e(),_c('creator-livestream-earnings')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }